import styled from 'styled-components'

const AlertBox = styled.div`
  width: 100%;
  border: 1px solid ${props => props.type === 'error' ? props.theme.cores.vermelhoErroCampoObrigatorio : '#086802'};
  color: ${props => props.type === 'error' ? props.theme.cores.vermelhoErroCampoObrigatorio : '#086802'};
  background-color: ${props => props.type === 'error' ? props.theme.cores.vermelhoErroBackground : '#f3f9ed'};
  font-weight: ${props => props.theme.fontWeight.l};
  font-size: ${props => props.theme.fontSize.xs};
  text-align: center;
  padding: 15px;
  margin-bottom: 10px;
`

export { AlertBox }
